import React, { useState } from 'react';
import { BoostingCalculator } from '../components/boosting/BoostingCalculator';
import { Zap, ShieldCheck, Video, Clock, CheckCircle, Users } from 'lucide-react';

export const BoostingPage: React.FC = () => {
  const [selectedGame, setSelectedGame] = useState('valorant');

  const games = [
    { slug: 'valorant', name: 'Valorant', icon: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?w=100' },
    { slug: 'league-of-legends', name: 'League of Legends', icon: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=100' },
    { slug: 'counter-strike-2', name: 'Counter-Strike 2', icon: 'https://images.unsplash.com/photo-1579373903781-fd5c0c30c4cd?w=100' },
    { slug: 'apex-legends', name: 'Apex Legends', icon: 'https://images.unsplash.com/photo-1538481199705-c710c4e965fc?w=100' },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-12">
      
      {/* Header */}
      <div className="text-center max-w-3xl mx-auto space-y-4">
        <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full text-xs font-semibold bg-amber-500/10 text-amber-600 dark:text-amber-400 border border-amber-500/20">
          <Zap className="w-4 h-4" />
          <span>Professional Rank Elevation & Coaching</span>
        </div>
        <h1 className="text-3xl sm:text-5xl font-black text-brand-lightText dark:text-brand-darkText tracking-tight">
          Achieve Your Dream Rank
        </h1>
        <p className="text-xs sm:text-sm text-brand-lightSecText dark:text-brand-darkSecText leading-relaxed">
          Order high-tier boosting and coaching from verified Radiant, Challenger, and Global Elite players. Live streaming and Duo Queue available on all titles.
        </p>

        {/* Game Switcher Tabs */}
        <div className="flex flex-wrap items-center justify-center gap-3 pt-4">
          {games.map((g) => (
            <button
              key={g.slug}
              onClick={() => setSelectedGame(g.slug)}
              className={`flex items-center gap-2 px-4 py-2 rounded-2xl border text-xs font-bold transition-all ${
                selectedGame === g.slug
                  ? 'border-brand-blue bg-brand-blue/10 text-brand-blue dark:text-brand-accent shadow-sm'
                  : 'border-brand-lightBorder dark:border-brand-darkBorder bg-white dark:bg-brand-darkCard text-brand-lightSecText hover:text-brand-lightText'
              }`}
            >
              <img src={g.icon} alt="" className="w-5 h-5 rounded-md object-cover" />
              <span>{g.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main Interactive Configurator */}
      <BoostingCalculator initialGame={selectedGame} />

      {/* Feature Highlights Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-6">
        <div className="p-6 rounded-2xl bg-white dark:bg-brand-darkCard border border-brand-lightBorder dark:border-brand-darkBorder space-y-3">
          <div className="w-10 h-10 rounded-xl bg-brand-blue/15 text-brand-blue dark:text-brand-accent flex items-center justify-center">
            <Users className="w-5 h-5" />
          </div>
          <h3 className="font-bold text-sm text-brand-lightText dark:text-brand-darkText">Duo Queue Self-Play</h3>
          <p className="text-xs text-brand-lightSecText dark:text-brand-darkSecText leading-relaxed">
            Play directly alongside your booster. You never have to share account passwords or risk account sharing warnings.
          </p>
        </div>

        <div className="p-6 rounded-2xl bg-white dark:bg-brand-darkCard border border-brand-lightBorder dark:border-brand-darkBorder space-y-3">
          <div className="w-10 h-10 rounded-xl bg-purple-500/15 text-purple-500 flex items-center justify-center">
            <Video className="w-5 h-5" />
          </div>
          <h3 className="font-bold text-sm text-brand-lightText dark:text-brand-darkText">Encrypted Private Stream</h3>
          <p className="text-xs text-brand-lightSecText dark:text-brand-darkSecText leading-relaxed">
            Watch your matches in real-time through an unlisted private link. Learn high-ELO crosshair placement, rotations, and decision making.
          </p>
        </div>

        <div className="p-6 rounded-2xl bg-white dark:bg-brand-darkCard border border-brand-lightBorder dark:border-brand-darkBorder space-y-3">
          <div className="w-10 h-10 rounded-xl bg-emerald-500/15 text-emerald-500 flex items-center justify-center">
            <ShieldCheck className="w-5 h-5" />
          </div>
          <h3 className="font-bold text-sm text-brand-lightText dark:text-brand-darkText">VPN & Offline Matching</h3>
          <p className="text-xs text-brand-lightSecText dark:text-brand-darkSecText leading-relaxed">
            Boosters utilize local VPN servers matching your country and city, playing in offline friend-list mode for complete privacy.
          </p>
        </div>
      </div>
    </div>
  );
};
